"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUnitGroupWithinScope = isUnitGroupWithinScope;
function getAncestorUnitGroups(unitGroup, propertyUnitGroups, ancestorUnitGroups) {
    if (ancestorUnitGroups === void 0) { ancestorUnitGroups = []; }
    var parentUnitGroupId = unitGroup.parentUnitGroupId;
    var parentUnitGroup = parentUnitGroupId
        ? propertyUnitGroups.find(function (u) { return u.unitGroupId === parentUnitGroupId; })
        : null;
    if (parentUnitGroup) {
        ancestorUnitGroups.push(parentUnitGroup);
        return getAncestorUnitGroups(parentUnitGroup, propertyUnitGroups, ancestorUnitGroups);
    }
    return ancestorUnitGroups;
}
function isUnitGroupWithinScope(unitGroupId, unitGroup) {
    if (unitGroup.unitGroupId === unitGroupId) {
        return true;
    }
    var ancestorUnitGroups = getAncestorUnitGroups(unitGroup, unitGroup.property.unitGroups);
    return ancestorUnitGroups.some(function (u) { return u.unitGroupId === unitGroupId; });
}
//# sourceMappingURL=isUnitGroupWithinScope.js.map